import {EventEmitter, Injectable} from '@angular/core';

/**
 * Class responsável pelo controle do componente de 'Loader'.
 */
@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    onChangeDisplay: EventEmitter<boolean>;

    constructor() {
        this.onChangeDisplay = new EventEmitter<boolean>();
    }

    public show(): void {
        this.onChangeDisplay.emit(true);
    }

    public hide(): void {
        this.onChangeDisplay.emit(false);
    }

}
